import DownloadMiniIcon from 'components/atoms/icons/downloadMiniIcon';
import React from 'react';
import { PropTypes } from 'prop-types';

const InformedConsent = ({ clickHandler }) => (
  <button className="informed-consent" onClick={clickHandler}>
    <span className="informed-consent__span">Informed Consent</span>
    <DownloadMiniIcon />
  </button>
);

InformedConsent.defaultProps = {
  clickHandler: () => {},
};

InformedConsent.propTypes = {
  clickHandler: PropTypes.func,
};

export default InformedConsent;
